// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"45":"861068c2","310":"9c0b2e63","476":"fdded0a8","610":"56502db4","810":"7f6c5839","853":"924b052f","928":"52b24f4a"}[chunkId] + ".css";
};